export default __webpack_public_path__ + "static/media/present.af14049a.png";